'use client'

import { FooterQueryResult } from '@repo/sanity/types'
import { Accordion, AccordionContent, AccordionItem, AccordionLinkTrigger, AccordionTrigger } from '@repo/ui/components/accordion'
import { LoaderCircleIcon } from 'lucide-react'
import { FunctionComponent } from 'react'
import useLocaleChange from '../../../hooks/useLocaleChange.hook'
import useLocalePrefetch from '../../../hooks/useLocalePrefetch.hook'
import { PageDto } from '../../../types/page.types'
import LinkResolver from '../../links/LinkResolver'
import LocaleButtons from '../LocaleButtonGroup'

interface Props {
  pageDto: PageDto
  footerLinks: NonNullable<FooterQueryResult>['footerLinks']
}

const FooterAccordion: FunctionComponent<Props> = ({ pageDto, footerLinks }) => {
  const { prefetch } = useLocalePrefetch(pageDto.params.locale)
  const { changeLocale, isLoading } = useLocaleChange(pageDto.params.locale)

  return (
    <Accordion type='single' collapsible={true} className='w-full lg:hidden'>
      <AccordionItem value='locale' variant='defaultAuto'>
        <AccordionTrigger onClick={prefetch}>
          <div>
            {pageDto.dictionary?.footer?.currency || 'Currency:'} {pageDto.marketInstance.currency}
            {isLoading && <LoaderCircleIcon className='text-muted relative -top-px ml-2 inline size-2.5 animate-spin' />}
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <LocaleButtons locale={pageDto.params.locale} isLoading={isLoading} onChange={(newLocale) => changeLocale(newLocale)} />
        </AccordionContent>
      </AccordionItem>
      {footerLinks?.map((footerLink) => {
        return (
          <AccordionItem key={footerLink._key} value={footerLink._key} variant='defaultAuto'>
            <AccordionLinkTrigger>
              <LinkResolver link={footerLink} locale={pageDto.params.locale}>
                {footerLink.label}
              </LinkResolver>
            </AccordionLinkTrigger>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default FooterAccordion
